import { createSlice } from "@reduxjs/toolkit";
import { format } from "date-fns/format";

import { UploadSessionFormValues } from "../../types";

export const initialState: UploadSessionFormValues = {
  sessionDate: format(new Date(), "yyyy-MM-dd"),
  selectedPlayer: { value: "", label: "" },
  sessionType: { value: "1", label: "Session" },
  sessionVenue: { value: "0", label: "Default Venue" },
  movementType: { value: "", label: "", slug: "" },
  frameRate: "",
  files: [],
  firstDrop: true,
  sessionId: "",
};

export const uploadSessionFormSlice = createSlice({
  name: "uploadSessionForm",
  initialState,
  reducers: {
    storeUploadSessionFormState: (state, action) => {
      state.sessionDate = action.payload.sessionDate;
      state.selectedPlayer = action.payload.selectedPlayer;
      state.sessionType = action.payload.sessionType;
      state.sessionVenue = action.payload.sessionVenue;
      state.movementType = action.payload.movementType;
      state.frameRate = action.payload.frameRate;
      state.files = action.payload.files;
      state.firstDrop = action.payload.firstDrop;
      state.sessionId = action.payload.sessionId;
    },
    clearUploadSessionFormState: (state) => {
      state = initialState;
      return state;
    },
  },
});
